import React from 'react';
import PropTypes from 'prop-types';

const ContactButton = ({ label, icon, href, onClick }) => {
  ContactButton.propTypes = {
    label: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    href: PropTypes.string,
    onClick: PropTypes.func.isRequired
  };

  return (
    <a
      className='btn btn-success btn-lg'
      href={href}
      onClick={onClick}
    >
      <span className='d-flex align-items-center pl-3 pr-3 text-white'>
        {label}{' '}
        <i className={`m-0 ml-3 h2 ${icon}`} />
      </span>
    </a>
  );
};

export default ContactButton;
